import { enUS } from '@white-label-configuration/lang';

export default enUS;
